import React, { useState } from 'react'
import { List, TextareaItem } from 'antd-mobile'
import {
  timestampToDate,
  getTextByKey,
  getTimeFormat,
  reportFn
} from '@feedback/utils/util'
import { Link } from 'react-router-dom'
import './index.scss'
import classNames from 'classnames'

const statusSet: any = {
  1: {
    text: getTextByKey('processing'), //'Wait',
    icon: ''
  },
  4: {
    text: getTextByKey('solved'),
    icon: ''
  },
  5: {
    text: getTextByKey('solved'),
    icon: ''
  },
  6: {
    text: getTextByKey('solved'),
    icon: ''
  },
  2: {
    text: getTextByKey('wait for your reply'),
    icon: ''
  },
  3: {
    text: getTextByKey('processing'),
    icon: ''
  }
}

function TicketItem({
  itemData,
  curFeedbackId,
  submitComment
}: {
  itemData: any
  curFeedbackId: any
  submitComment: any
}) {
  const [isOpenCommom, setIsOpenCommon] = useState<boolean>(
    curFeedbackId === itemData._id
  )
  const [score, setScore] = useState<number>(0)
  const [comment, setComment] = useState<string>('')

  const handleSubmit = () => {
    reportFn({ parm1: 4, parm2: 2, parm6: itemData._id })
    submitComment({ feedback_id: itemData._id, comment: comment, star: score })
  }
  return (
    <div className='c-ticket-item'>
      <Link to={`/v1/ticketDetail?feedback_id=${itemData._id}`}>
        <div className='item-header'>
          {<div className='red-idot'></div>}
          <span className='no'>
            {getTextByKey('feedback id')}：{itemData.work_order}
          </span>
          <span className='time'>{getTimeFormat(itemData.created_at)}</span>
        </div>
        <div className='item-body'>
          <p className='desc'>{itemData.content}</p>
          <div className={`status ${'status' + itemData.feedback_status}`}>
            {statusSet[itemData.feedback_status]
              ? statusSet[itemData.feedback_status].text
              : ''}
          </div>
        </div>
      </Link>
      {itemData.feedback_status === 4 && (
        <div className='item-footer'>
          {isOpenCommom && (
            <>
              <ul className='star-list'>
                {[1, 2, 3, 4, 5].map((item, index) => (
                  <li
                    className={`star-item ${
                      score > index ? 'star-item-selected' : ''
                    }`}
                    key={index}
                    onClick={() => {
                      setScore(item)
                    }}
                  />
                ))}
              </ul>
              <div className='comment-form'>
                <List>
                  <TextareaItem
                    rows={5}
                    count={150}
                    onChange={(val: string | undefined) => {
                      setComment(val || '')
                    }}
                    placeholder={getTextByKey(
                      'leave some comments on our service'
                    )}
                  />
                </List>
              </div>
            </>
          )}
          <div className='btn-group'>
            {!isOpenCommom ? (
              <span
                className='btn-open'
                onClick={() => {
                  reportFn({ parm1: 4, parm2: 1, parm6: itemData._id })
                  setIsOpenCommon(true)
                }}
              >
                {getTextByKey('rate our service')}
              </span>
            ) : score > 0 ? (
              <span className='btn btn-submit' onClick={handleSubmit}>
                {getTextByKey('submit')}
              </span>
            ) : (
              <span
                className='btn btn-pack'
                onClick={() => {
                  setIsOpenCommon(false)
                }}
              >
                {getTextByKey('collapse')}
              </span>
            )}
          </div>
        </div>
      )}
      {itemData.feedback_status === 5 && (
        <div className='item-footer'>
          <ul className='star-list star-list-single'>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <li
                className={`star-item ${
                  itemData.star > index ? 'star-item-selected' : ''
                }`}
                key={index}
              />
            ))}
          </ul>
          <p className={classNames('desc', 'commentSty')} style={{}}>
            {itemData.comment}
          </p>
        </div>
      )}
    </div>
  )
}
export default TicketItem
